<template>
    <div>
        <div class="ksper bg-dark fixed-top">
            <b-container>
                <b-row>
                    <b-col lg="12" class="ksper">
                        <div class="d-flex justify-content-between" style="">
                            <span><svgicon icon="check-mark" width="16" height="16" color="#aea399" />14 dages returret</span>
                            <!-- <span><svgicon icon="check-mark" width="16" height="16" color="#aea399" />Prisgaranti</span> -->
                            <span class="d-none d-lg-block"><svgicon icon="check-mark" width="16" height="16" color="#aea399" />Hurtig levering, 1-2 hverdage</span>
                            <span class="d-none d-md-block d-lg-none"><svgicon icon="check-mark" width="16" height="16" color="#aea399" />Hurtig levering</span>
                            <span><svgicon icon="check-mark" width="16" height="16" color="#aea399" />Gratis fragt v/ køb for min 1000,-</span>
                            <span><trustpilot /></span>
                            <!-- <span><svgicon icon="check-mark" width="16" height="16" color="#aea399" />E-handelsmærket</span> -->
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div style="height:45px">&nbsp;</div>
    </div>
</template>
<script>
    import trustpilot from "./trustpilot/trustpilotDropDown.vue";
    import "../../icons/_rk/check-mark";
    export default {
        components:{
            trustpilot
        },
    }
</script>
<style lang="scss" scoped>
@import "../colors";
    .ksper
    {
        // background-color:#aea399;
        // background-color:$rkDarktop;
        color:$rkBrown;
        padding: 6px 0;
        font-size:14px;
        font-weight: 700;
        span{
            margin:0 10px;
        }
        svg
        {
            margin-right:2px;
            margin-bottom:3px;
        }
    }
</style>
